import { useWindowSize } from '@vueuse/core' // 这里不能使用'@/hooks'，会造成循环调用
import merge from 'deepmerge'
import { imgClip } from 'shared'
import cssVar from '@/assets/css/global.module.scss'
import { isTpad } from './toolBridge'
import dayjs from 'dayjs'


// 导出所有css变量
export * from '@/assets/css/global.module.scss'

// 导出qs
export { default as qs } from 'qs'

// sass变量
const { planWidth, screenSplit, screenMin, screenMax, screenUnit } = cssVar

// 设计图尺寸对应的最大适配尺寸，并向上取舍
export const getPlanMaxSize = size => Math.ceil(size / planWidth * screenMax)

// 导出判断浏览器是否支持webgl方法
export { supportWebGL, uuid } from 'core'

// 导出图片压缩方法
export { imgClip } from 'shared'

// 传入设计图尺寸，返回最大适配尺寸的值
export const imgClipPlan = (...arg) => {
  if (arg.length <= 1) return imgClip(...arg)

  if (arg[1] === 'object') {
    arg[1].w && (arg[1].w = getPlanMaxSize(arg[1].w))
    arg[1].h && (arg[1].h = getPlanMaxSize(arg[1].h))
  } else {
    arg[1] = getPlanMaxSize(arg[1])
  }

  arg[2] && (arg[2] = getPlanMaxSize(arg[2]))

  return imgClip(...arg)
}

// 导出cookie
export { default as cookie } from 'js-cookie'

// 导出isMobile
export { default as isMobile } from 'is-mobile'

// 深度合并
export const deepMerge = merge

// 深度拷贝
export const deepCopy = obj => merge({}, obj)

// 首字母大写
export const titleCase = str => str.charAt(0).toUpperCase() + str.slice(1)

// 字符串转驼峰
export const formatToHump = (() => {
  const cache = {}

  return str => cache[str] || (cache[str] = str?.replace?.(/[-_](\w)/g, (_, letter) => letter.toUpperCase()))
})()

// 获取对应环境
export const getEnv = (() => {
  let cache
  const getFn = () => {
    if (/-dev|localhost|(\d{1,3}\.){3}/.test(location.hostname)) return 'test' // (\d{1,3}\.){3} 是ip的简单匹配
    if (/-test|-local/.test(location.hostname)) return 'test'
    if (/-stg/.test(location.hostname)) return 'stg'
    return 'prod'
  }

  return () => cache || (cache = getFn())
})()
// ¥32,000
// 格式化价格为千分位
export const formatPrice = (price,showZero = false) => {
  if(!price) return showZero ? '¥0' : '价格已包含'
  return '¥' + price.toLocaleString('en')
}
// export const formatPrice = price => String(price || '').replace(/\B(?=(\d{3})+$)/g, ',')

/**
 * 选配主价展示文案：优先套装/包价文案，再回退数值价（与 Web SelectCard、DialogCard、PriceAndDesc 等一致）
 * @param {Object} [row] - option 或含 price、display_price、display_price_text、package_price_desc、origin_price 等字段
 */
export const getMainPriceText = (row) => {
  const current = row || {}
  if (current.display_price_text) return current.display_price_text
  if (current.package_price_desc) return current.package_price_desc
  // 有套装价格时（包括套件已包含这种特殊情况），都不展示划线价；没套装价格的按配置器有优惠的话正常展示划线价
  if (current.package_price) return formatPrice(current.package_price)
  const priceToShow = current.display_price ?? current.price
  const price = priceToShow ? Number(priceToShow) : priceToShow
  return formatPrice(price, current.origin_price)
}

// 返回一个rem值，避免窗口切换重复计算px值
export const rem = (() => {
  const { width: screenWidth } = useWindowSize()
  const width = computed(() => Math.min(screenMax, Math.max(screenMin, screenWidth.value)))

  return n => parseInt(n) / width.value * screenSplit + screenUnit
})()

// 返回浏览器类型只读对象
export const brower = (() => {
  const userAgent = navigator.userAgent

  return readonly({
    isSafari: /Safari/.test(userAgent) && !/Chrome/.test(userAgent)
  })
})()

// 返回浏览器是否支持css属性
export const supportCss = (() => {
  const style = document.createElement('div').style
  const cache = {}

  return css => {
    if (typeof cache[css] === 'boolean') return cache[css]

    const Css = titleCase(css)
    return cache[css] = [css, 'webkit' + Css, 'moz' + Css, 'o' + Css].some(css => style[css] !== undefined)
  }
})()

// 防抖
export const debounce = (fn, delay = 300) => {
  let timer

  return function (...arg) {
    clearTimeout(timer)
    timer = setTimeout(() => fn.call(this, ...arg), delay)
  }
}

// 节流
export const throttle = (fn, delay = 300) => {
  let allow = true

  return function (...arg) {
    if (!allow) return
    allow = false
    setTimeout(() => {
      allow = true
      fn.call(this, ...arg)
    }, delay)
  }
}

/**
 * 空对象
 */
export const isEmptyObj = (obj) => {
  return JSON.stringify(obj) === '{}'
}

// // 继承对象
// export const inheritObject = (superObject, props) => {
//   const obj = Object.create(superObject)
//   props && Object.keys(props).forEach(key => (obj[key] = props[key]))
//   return obj
// }

//  判断当前页面是配置器页面还是配置总览页面,2个页面的交互不一致

export const isOverViewPage = () => {
  // configurator/overview
  return window.location.href.indexOf('configurator/overview') != -1;
}

// 
export const getQueryString = (name,url_string) => {
 // const url_string = "https://www.baidu.com/t.html?name=mick&age=20"; // window.location.href
  const url = new URL(url_string);
  return url.searchParams.get(name);
}



const CampaignCodeMap = {
  'dev': 'M3mLRIRV',
  'test': 'M3mLRIRV',
  'stg': 'xlby6Ayd',
  'prod': 'lcM1Y0le'
}
export const getCampaignCode = () =>{
  if(!isTpad) return ''
  return  CampaignCodeMap[getEnv()] || 'lcM1Y0le'
}

const saleCarUrlMap = {
  'dev': 'https://pad-car-dev.nioint.com/',
  'test': 'https://pad-car-test.nioint.com/',
  'stg': 'https://pad-car-stg.nio.com/',
  'prod': 'https://pad-car.nio.com/'
}
export const getSaleCarPath = (path,params) => {
  let host =  saleCarUrlMap[getEnv()] || 'https://pad-car.nio.com/'
  return withUrl(host,path,params)
}


const carConfigUrlMap = {
  'dev': 'https://www-cn-dev.nioint.com/configurator/',
  'test': 'https://www-cn-test.nioint.com/configurator/',
  'stg': 'https://www-cn-stg.nioint.com/configurator/',
  'prod': 'https://www.nio.cn/configurator/'
}
export const getCarConfigPath = (path,params) => {
  let host =  carConfigUrlMap[getEnv()] || 'https://www.nio.cn/configurator/'
  return withUrl(host,path,params)
}

const withUrl = (host,path,params) =>{
  let  url = ''
  if(params){
    const queryString = new URLSearchParams(Object.entries(params)).toString();
     url = `${host}${path}?${queryString}`
  }else{
    url = `${host}${path}`
  }
  return url
}


export const setModelListTool = (category_list) => {
  const list = [];
  category_list.forEach((category) => {
    category?.model_list.forEach((item) => {
      list.push(item);
    });
  });
  return list;
};

/** 格式化日期 */
export const formatDate = (date = '', format = 'YYYY/MM/DD HH:mm') => {
  try {
    const day = String(date).length === 10 ? dayjs.unix(date) : dayjs(date)

    return day.format(format)
  } catch (error) {
    console.error(error)

    return date
  }
}

/**
 * 判断是不是字符串
 */
export const isString = (str) => {
  return typeof str === 'string'
}
/**
 * 判断是不是对象
 */
export const isObject = (obj) => {
  return Object.prototype.toString.call(obj) === '[object Object]'
}